// style
import './style/barline.css'
// swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
// option
import { swiperOption } from "../../../features/swiperOption/swiperOption.tsx";
// Import Swiper styles
import 'swiper/css';
import "swiper/css/pagination"
import "swiper/css/navigation"
// react
import React from 'react';

const Barline = () => {
    return (
        <>
            <Swiper
                className={'page-slider w-100'}
                modules={[Autoplay, Navigation]}
                navigation={{
                    prevEl: '.next',
                    nextEl: '.prev',
                }}
                loop={true}
                spaceBetween={10}
                autoplay={{
                    delay: 3500,
                    disableOnInteraction: false,
                }}
                breakpoints={
                    swiperOption
                }
            >
                {/* item */}
                <SwiperSlide>
                    <div className={'item'} data-aos="zoom-in-up" data-aos-duration={'1500'}>
                        <div className={'card card-body mb-1'}>
                            <img alt={'activity'}
                                src={require('./../../../assets/media/icon/icon5_prev_ui.png')}
                                className={'img-fluid'} />
                            <h6 className={'card-title fw-bold mb-0 text-center'}>تحویل 24 ساعته</h6>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={'item'} data-aos="zoom-in-down" data-aos-duration={'1500'}>
                        <div className={'card card-body'}>
                            <img alt={'activity'}
                                src={require('./../../../assets/media/icon/icon4_prev_ui.png')}
                                className={'img-fluid'} />
                            <h6 className={'card-title fw-bold mb-0 text-center'}>بهترین کیفیت</h6>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={'item'} data-aos="zoom-in-up" data-aos-duration={'1500'}>
                        <div className={'card card-body'}>
                            <img alt={'activity'}
                                src={require('./../../../assets/media/icon/icon1_prev_ui.png')}
                                className={'img-fluid'} />
                            <h6 className={'card-title fw-bold mb-0 text-center'}>بازگشت وجه</h6>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={'item'} data-aos="zoom-in-down" data-aos-duration={'1500'}>
                        <div className={'card card-body'}>
                            <img alt={'activity'}
                                src={require('./../../../assets/media/icon/icon2_prev_ui.png')}
                                className={'img-fluid'} />
                            <h6 className={'card-title fw-bold mb-0 text-center'}>تور مجازی</h6>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={'item'} data-aos="zoom-in-up" data-aos-duration={'1500'}>
                        <div className={'card card-body'}>
                            <img alt={'activity'}
                                src={require('./../../../assets/media/icon/icon3_prev_ui.png')}
                                className={'img-fluid'} />
                            <h6 className={'card-title fw-bold mb-0 text-center'}>پشتیبانی 24 ساعته</h6>
                        </div>
                    </div>
                </SwiperSlide>
                <div className="prev">
                    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34"
                        viewBox="0 0 34 34" fill="none">
                        <path
                            d="M17 34C26.3888 34 34 26.3888 34 17C34 7.61116 26.3888 0 17 0C7.61116 0 0 7.61116 0 17C0 26.3888 7.61116 34 17 34Z"
                            fill="#26466d" fillOpacity="0.61" />
                        <path d="M19.142 23.001L13.158 17L19.142 10.999" stroke="white"
                            strokeWidth="1.5" strokeLinecap="round"
                            strokeLinejoin="round" />
                    </svg>
                </div>
                <div className="next">
                    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34"
                        viewBox="0 0 34 34" fill="none">
                        <path
                            d="M16.8334 33.8333C7.53661 33.8333 6.10352e-05 26.2968 6.10352e-05 17C6.10352e-05 7.70317 7.53661 0.166626 16.8334 0.166626C26.1302 0.166626 33.6667 7.70317 33.6667 17C33.6667 26.2968 26.1302 33.8333 16.8334 33.8333Z"
                            fill="#26466d" fillOpacity="0.61" />
                        <path d="M14.7124 22.9422L20.6377 17L14.7124 11.0579" stroke="white"
                            strokeWidth="1.5" strokeLinecap="round"
                            strokeLinejoin="round" />
                    </svg>
                </div>
            </Swiper>
        </>
    )
}

export default Barline;